(() => {
  const initialize = (root = document) => {
    root.querySelectorAll("[data-harder-how-play]").forEach((button) => {
      if (button.dataset.harderHowReady === "true") return;

      const media = button.closest("[data-harder-how-media]");
      const video = media?.querySelector("video");
      if (!video) return;

      button.dataset.harderHowReady = "true";
      button.addEventListener("click", async () => {
        video.controls = true;
        try {
          await video.play();
          media.classList.add("is-playing");
        } catch (_error) {
          video.controls = true;
        }
      });

      video.addEventListener("pause", () => {
        if (video.currentTime === 0 || video.ended) media.classList.remove("is-playing");
      });
    });
  };

  document.addEventListener("DOMContentLoaded", () => initialize());
  document.addEventListener("shopify:section:load", (event) => initialize(event.target));
})();
